import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=3196c0a5&scoped=true&"
import script from "./UploadComponent.vue?vue&type=script&lang=js&"
export * from "./UploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196c0a5",
  null
  
)

export default component.exports